import { Media, MediaType, SoundMediaType } from '@arpeggi/shared'
import { useAuth } from '../../../__legacy__/hooks/useAuth'
import { objectToFormData } from '../../../__legacy__/utils/api'

interface CreateDTO {
  title: string
  description?: string
  mediaType: MediaType
  userWalletAddress: string
  soundFile: File
  soundMetadata: {
    bpm?: number
    key?: number
    tags?: string[]
    type: SoundMediaType
  }
  isPreview?: boolean
  parentId?: number
}

export const useMediaCrud = () => {
  const { authenticatedPost } = useAuth()

  const create = async (dto: CreateDTO) => {
    const { data } = await authenticatedPost<Media>('/api/v2/media', objectToFormData(dto))

    return data
  }

  return { create }
}
